import { call, put, takeLatest } from 'redux-saga/effects';
import { SagaPayload } from '@utils/typescript';
import { otpTokenFetch, stateUpdate, StateUpdatePayload } from './action';
import { OtpApi, AuthOtpTokenGenerateParams } from '@apis/OtpApi';
import i18n from '@components/i18n';

function* handleOtpTokenFetch({ payload }: SagaPayload<AuthOtpTokenGenerateParams>) {
  const state: StateUpdatePayload = { otpResetUrl: '', errors: [] };
  try {
    const { otpToken } = (yield call(OtpApi.generateOtpToken, payload)) as { otpToken: string };
    state.otpResetUrl = `${window.location.origin}/${i18n.language}/sign-in/otp-link/${otpToken}`;
    yield put(stateUpdate(state));
  } catch (error) {
    state.errors?.push((error as Error).message);
    yield put(stateUpdate(state));
  }
}

export default function* () {
  yield takeLatest(otpTokenFetch, handleOtpTokenFetch);
}
